// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1-fUz","range":"MonthRangeSwitch_range__3GS-y","disabled":"MonthRangeSwitch_disabled__2Dcx0"};